module.exports = __webpack_public_path__ + "img/2 cleaning.605622f7.jpeg";